import React, { FC } from 'react';

const Settings: FC = () => <span>Settings</span>;

Settings.displayName = 'Settings';

export default Settings;
